// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"a13e0012","110":"1d4a97df","187":"8ae35704","348":"afa5f1d2","357":"d221ab47","376":"a0d4d2b4","445":"2224aff3","477":"aa26de25","488":"70dcce4a","651":"2c3fe725","980":"69c28212","998":"abe8de91"}[chunkId] + ".chunk.js";
};